import getTodoRequestHeaders from './getTodoRequestHeaders';
import { format } from 'owa-strings';
import { GetTasksResponse, GetTasksServiceResponse } from './GetTasksServiceResponse';
import { makeGetRequest } from 'owa-ows-gateway';
import {
    TODO_API_GET_TASKS_IN_FOLDER_FORMAT,
    TODO_API_DEFAULT_FOLDER,
    TODO_API_GET_TASKS_IN_DEFAULT_FOLDER_URL,
} from './constants';

/**
 * Makes the Get tasks call to the server to get task items for the specified folder
 * or the default tasks folder if not specified.
 * @param {string} folderId optional folder id of requested task folder
 * @returns promise of GetTasksServiceResponse
 */
export default async function getTasksService(folderId?: string): Promise<GetTasksServiceResponse> {
    const folderIdToUse = folderId ? folderId : TODO_API_DEFAULT_FOLDER;
    const url = format(TODO_API_GET_TASKS_IN_FOLDER_FORMAT, folderIdToUse);

    let taskResponse = await makeTodoGetRequest(url);
    /** TODO VSO 38608: this retry logic is needed when the user is a notes user, because of recent regression */
    if (taskResponse.StatusCode === 404) {
        const retryURL = format(TODO_API_GET_TASKS_IN_DEFAULT_FOLDER_URL, folderIdToUse);
        taskResponse = await makeTodoGetRequest(retryURL);
    }
    return taskResponse;
}

function makeTodoGetRequest(url: string): Promise<GetTasksServiceResponse> {
    return makeGetRequest(
        url,
        null /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders()
    )
        .then(async (response: Response) => {
            const responseBody = <GetTasksResponse>await response.json();
            return {
                StatusCode: response.status,
                ResponseBody: responseBody,
            };
        })
        .catch(err => {
            return null;
        });
}
